<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      content: {
        label: "",
        letter: "",
      },
    };
  },
  mounted() {
    this.translateLabel();
  },
  methods: {
    translateLabel() {
      this.content.label = this.name;
      this.content.letter = this.content.label.charAt(0);
      this.content.letter = this.content.letter.toUpperCase();
      const lang = document.documentElement.lang;
      if (lang === "nb-NO") {
        if (this.name === "fundamentals") {
          this.content.label = "basis";
          this.content.letter = this.content.label.charAt(0);
          this.content.letter = this.content.letter.toUpperCase();
        } else if (this.name === "braceworks") {
          this.content.label = this.name;
          this.content.letter = "Br";
        }
      } else if (lang === "fr-FR") {
        if (this.name === "fundamentals") {
          this.content.label = "standard";
          this.content.letter = "St";
        } else if (this.name === "architect") {
          this.content.label = "architecture";
          this.content.letter = this.content.label.charAt(0);
          this.content.letter = this.content.letter.toUpperCase();
        } else if (this.name === "landmark") {
          this.content.label = "paysage";
          this.content.letter = this.content.label.charAt(0);
          this.content.letter = this.content.letter.toUpperCase();
        }
      } else if (lang === "de-DE" || lang === "de-CH" || lang === "de-AT") {
        if (this.name === "fundamentals") {
          this.content.label = "basic";
          this.content.letter = this.content.label.charAt(0);
          this.content.letter = this.content.letter.toUpperCase();
        } else if (this.name === "architect") {
          this.content.label = "architektur";
          this.content.letter = this.content.label.charAt(0);
          this.content.letter = this.content.letter.toUpperCase();
        } else if (this.name === "landmark") {
          this.content.label = "landschaft";
          this.content.letter = this.content.label.charAt(0);
          this.content.letter = this.content.letter.toUpperCase();
        } else if (this.name === "braceworks") {
          this.content.label = this.name;
          this.content.letter = "Br";
        }
      } else if (lang === "nl-NL") {
        if (this.name === "fundamentals") {
          this.content.label = "standaard";
          this.content.letter = "St";
        } else if (this.name === "architect") {
          this.content.label = "architectuur";
          this.content.letter = this.content.label.charAt(0);
          this.content.letter = this.content.letter.toUpperCase();
        } else if (this.name === "landmark") {
          this.content.label = "landschap";
          this.content.letter = this.content.label.charAt(0);
          this.content.letter = this.content.letter.toUpperCase();
        }
      }
      return this.content;
    },
  },
};
</script>
<template>
  <div :class="{ active: isActive }" class="indicatorIcon">
    <div class="tooltip">
      <span class="tooltipCopy">{{ content.label }}</span>
    </div>
    <div class="icon">
      <span>{{ content.letter }}</span>
    </div>
    <!-- <svg
      xmlns="http://www.w3.org/2000/svg"
      xml:space="preserve"
      viewBox="0 0 18 18"
    >
      <circle cx="9" cy="9" r="8.5" />
      <component :is="name" />
    </svg> -->
  </div>
</template>

<style lang="scss" scoped>
.indicatorIcon {
  position: relative;
  width: var(--size);
  height: var(--size);
  margin-left: var(--gap);
  &:first-child {
    margin-left: 0;
  }
}
.active {
  .icon {
    background-color: var(--hover-color);
  }
}
.indicatorIcon:hover .tooltip {
  opacity: 1;
}

.tooltip {
  opacity: 0;
  position: absolute;
  width: max-content;
  bottom: 160%;
  left: calc(var(--size) / 2);
  pointer-events: none;
  filter: drop-shadow(0 2px 9px rgba(0, 0, 0, 0.1));
}
.tooltip:after {
  content: "";
  position: absolute;
  top: 100%;
  left: 0%;
  margin-left: -10px;
  // transform: translateX(-50%);
  border: solid transparent;
  border-top-color: var(--tooltip-bg);
  border-width: 10px;
  pointer-events: none;
}
.tooltipCopy {
  background-color: var(--tooltip-bg);
  color: var(--tooltip-color);
  border-radius: 5px;
  font-size: 14px;
  margin-left: -50%;
  text-transform: capitalize;
  padding: 15px;
  width: 100%;
  display: block;
}

svg {
  width: var(--size);
  height: var(--size);
}

.indicatorIcon {
  position: relative;
}
circle {
  // cursor: pointer;
  fill: var(--dark-color);
}
.icon {
  background-color: var(--dark-color);
  border: 1px solid var(--light-color);
  width: var(--size);
  height: var(--size);
  border-radius: 50%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    color: var(--light-color);
    // text-transform: uppercase;
    font-size: 10px;
    font-weight: 500;
    cursor: pointer;
    // top: 0px;
    // position: absolute;
    // left: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/vuejs/frontend/2023-launch/components/ProductIndicatorIcon.vue